import React, { useCallback, useMemo } from "react";
import FormInputDate from "customization/ui/FormInputDate/FormInputDate";

import { useValidity } from "customization/templates/FieldTemplate/FieldTemplate";

const DateWidget = ({
  onChange,
  value,
  onBlur,
  onFocus,
  readonly,
  rawErrors,
  options,
  disabled,
  id,
  name,
  autofocus,
  placeholder,
  ...rest
}) => {
  const { isInvalid, handleOnBlur } = useValidity();

  let { minDate, maxDate } = options;

  if (!maxDate) {
    let today = new Date().toISOString().slice(0, 10);
    maxDate = today;
  }

  const handleChange = useCallback((e) => {
    onChange(e.target.value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const calendarProps = useMemo(
    () => ({
      minDate,
      maxDate,
    }),
    [minDate, maxDate]
  );

  delete rest.formContext; // Avoid bug

  return (
    <div style={{ zIndex: 999 }}>
      <FormInputDate
        id={id}
        name={name}
        onChange={handleChange}
        invalid={isInvalid}
        value={value == null ? "" : value}
        onBlur={
          onBlur &&
          ((event) => {
            handleOnBlur();
            onBlur(id, event.target.value);
          })
        }
        onFocus={onFocus}
        readOnly={readonly}
        autoFocus={autofocus}
        disabled={disabled}
        calendarProps={calendarProps}
        {...rest}
      />
    </div>
  );
};

export default DateWidget;
